import React from 'react';
import { BaasicDropzone, Loader, BaasicHeader, BaasicButton, BaasicDropdown } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import { InventorySyncList } from 'modules/product-inventory/pages';
import moment from 'moment';

const InventorySyncTemplate = ({ inventorySyncPageViewStore, t }) => {
	const {
		form,
		loading,
		fileSelected,
		confirmDisabled,
		updateInventory,
		downloadTemplate,
		fileName,
		lastModifyFileDate,
		rootStore,
		warehouseDropdownStore
	} = inventorySyncPageViewStore;
	var uploadType = '.xls, .xlsx, .csv';
	if (loading) return <Loader />;
	return (
		<section className="layout__main__body">
			<BaasicHeader title="MAINMENU.ADMINISTRATION.INVSYNC" rootStore={rootStore}>
				<BaasicButton
					className="btn btn--med btn--primary btn--primary--negative"
					onClick={downloadTemplate}
					icon="fa fa-download spc--right--sml"
					label="INVENTORYSYNC.DOWNLOADTEMPLATE"
				/>
			</BaasicHeader>
			<React.Fragment>
				<form className="container container--footer container--inventory-reconciliation" onSubmit={form.onSubmit}>
					<div>
						<div className="row">
							<div className="col col-sml-12 col-lrg-4">
								<div>
									<BaasicDropzone
										acceptFiles={uploadType}
										onFilesDrop={inventorySyncPageViewStore.onFilesDrop}
										field={form.$('excel')}
									/>
								</div>
								<p className="spc--bottom--sml type--center">{t('INVENTORYSYNC.EXCEL')}</p>
							</div>
							<div className="col col-sml-12 col-lrg-8">
								{fileSelected ? (
									<h6 className="spc--bottom--sml">
										{t('INVENTORYSYNC.FILENAME') +
											fileName +
											' - ' +
											t('INVENTORYSYNC.DOCDATE') +
											moment(lastModifyFileDate).format('l LT')}{' '}
									</h6>
								) : null}
								{fileSelected ? (
									<BaasicDropdown dropdownStore={warehouseDropdownStore} className="w--400--px" />
								) : null}
							</div>
						</div>
					</div>
					<InventorySyncList viewStore={inventorySyncPageViewStore} />
					<div className="container__footer type--right">
						<button
							className="btn btn--med btn--success spc--bottom--sml"
							type="button"
							disabled={confirmDisabled}
							onClick={updateInventory}
						>
							{t('CONFIRM')}
						</button>
					</div>
				</form>
			</React.Fragment>
		</section>
	);
};

export default defaultTemplate(InventorySyncTemplate);
